import { Component } from '@angular/core';

export interface Partner {
  src: string;
  alt: string;
}

@Component({
  selector: 'app-partners',
  standalone: true,
  imports: [],
  template: `
    <div class="ticker-wrapper py-2">
      <!-- Duplicate the list so the seam is invisible at 50% -->
      <div class="ticker-track">
        @for (p of doubled; track $index) {
          <div
            class="shrink-0 flex items-center justify-center rounded-xl overflow-hidden transition-all duration-300 hover:scale-105"
            style="
              width:100px;height:100px;
              background:var(--glass-bg);
              border:1px solid var(--theme-border)
            "
          >
            <img
              [src]="p.src"
              [alt]="p.alt"
              class="w-21 h-21 object-contain rounded-xl"
              loading="lazy"
              decoding="async"
              width="84"
              height="84"
            />
          </div>
        }
      </div>
    </div>
  `,
})
export class PartnersComponent {
  private readonly partners: Partner[] = [
    { src: '/assets/images/bm.jpg',    alt: 'BM partner'      },
    { src: '/assets/images/bpn.jpg',   alt: 'BPN partner'     },
    { src: '/assets/images/cmu.jpg',   alt: 'CMU partner'     },
    { src: '/assets/images/abanoub.jpg', alt: 'Abanoub'       },
    { src: '/assets/images/simba.jpg', alt: 'Simba partner'   },
    { src: '/assets/images/rodas.jpg', alt: 'Rodas partner'   },
    { src: '/assets/images/wsh.jpg',   alt: 'WSH partner'     },
  ];

  /** Duplicate so seamless loop works at translateX(-50%) */
  get doubled(): Partner[] {
    return [...this.partners, ...this.partners];
  }
}
